function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.999,
    height: 16,
    viewBox: "0 0 15.999 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19338"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19337"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59549",
    d: "M15.515 131a.5.5 0 0 0-.5.5v5.662l-4 1.6V133.5a.5.5 0 1 0-1 0v5.261l-4-1.6v-7.922l2.317.927a.5.5 0 0 0 .371-.929l-2.993-1.2h-.008a.5.5 0 0 0-.371 0h-.009l-4.991 2a.5.5 0 0 0-.314.464v9a.5.5 0 0 0 .686.464l4.814-1.925 4.8 1.922h.009a.5.5 0 0 0 .371 0h.009l4.991-2a.5.5 0 0 0 .313-.465v-6a.5.5 0 0 0-.495-.497zm-10.5 6.161-4 1.6v-7.923l4-1.6z",
    transform: "translate(-.016 -124)",
    style: {
      fill: "#0a243f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19340"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19339"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59550",
    d: "M353.516 64a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5zm0 2a.5.5 0 1 1 .5-.5.5.5 0 0 1-.5.5z",
    transform: "translate(-341.017 -62)",
    style: {
      fill: "#0a243f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19342"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19341"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59551",
    d: "M291.516 0a3.5 3.5 0 0 0-3.5 3.5c0 1.8 2.808 4.977 3.128 5.334a.5.5 0 0 0 .744 0c.32-.357 3.128-3.538 3.128-5.334a3.5 3.5 0 0 0-3.5-3.5zm0 7.737c-1.092-1.295-2.5-3.283-2.5-4.237a2.5 2.5 0 0 1 5 0c0 .953-1.408 2.942-2.5 4.237z",
    transform: "translate(-279.017)",
    style: {
      fill: "#0a243f"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.a5d66d3e1e7ecf517e78cf76ddc30441.svg";
export { ForwardRef as ReactComponent };